import axios from 'axios'
import Vue from 'vue'
import { ACCESS_TOKEN } from '../store/mutation-types'
import { loginAuthUrl } from './api'
import store from '../store'
import { Toast, Dialog } from 'vant'
import router from '@/router'
import { getUrlParms } from '@/utils/comm'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.baseURL

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const token = Vue.ls.get(ACCESS_TOKEN)
  const invCode = getUrlParms('qrCode')
  if (invCode) {
    localStorage.setItem('invCode', invCode)
  }
  if (token) {
    config.headers['xf_token'] = `${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
    config.headers['inv_code'] = `${localStorage.getItem('invCode')}`
    config.headers['type'] = 'wx_public'
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use((response) => {
  // 针对后端返回标识 做退出操作
  if (response.data.code && ((response.data.code).toString() === '401' || (response.data.code).toString() === '1001')) {
    store.dispatch('Logout')
  }
  return response.data
}, (error) => {
  return Promise.reject(error)
})
export const apiGet = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      if (res.code === 1000 && window.location.href.indexOf('/bindPhone') < 0) {
        Dialog.confirm({
          title: '绑定手机号',
          message: '是否要去绑定手机号',
        })
          .then(() => {
            router.push({
              path: '/bindPhone',
              query: {
                code: getUrlParms('qrCode')
              }
            })
          })
          .catch(() => {
            router.back()
          })
        return
      } else if (res.code === 1001) {
        Toast(res.msg)
        setTimeout(() => {
          window.location.href = loginAuthUrl + `?to_url=${process.env.viewURL}/personal`
        }, 500)
        return
      }
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export const apiPost = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export const apiPatch = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.patch(url, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export const apiAxios = axios



// WEBPACK FOOTER //
// ./src/api/index.js